import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'toBooleanIcon' })
export class BooleanIconPipe implements PipeTransform {
  transform(value: boolean): string {
    if (value) {
      return '<span class="material-symbols-outlined text-success">check</span>';
    } else {
      return '<span class="material-symbols-outlined text-danger">close</span>';
    }
  }
}
